/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect, useRef, useState} from 'react';
import Papa from 'papaparse';
import * as XLSX from 'xlsx';
import {Teams, Utils} from '../../../utils/api';
import {SpreadSheet} from '../../../assets/icons/icons';
import {ARMcontext} from '../../../utils/context/context';
import {AdBodyFormRole, AdBodyFormSearch} from './styles';
import {useInputValue} from '../../../utils/hooks/useInputValue';
import {
  InputComponent,
  Label,
  LargeButton,
  PowerInput,
  Radio,
  TableAddCoaches,
  TextWarning,
  TableFailedInvitations,
  Modal,
  ExpandedButton,
  Loader,
} from '../../../components';
import {
  AdBody,
  AdHeader,
  AdFooter,
  AdBodyForm,
  AdBodyTitle,
  AdBodyFormUp,
  RadiosContainer,
  AdBodyBulk,
  AdBodyBulkAdvise,
  AdBodyBulkCenter,
  AdBulkFooter,
  AdBulkBody,
  AdBodyFormHeader,
  AdBodyFormIcon,
} from '../styles';

const IndividualItem = ({teamMemo, index, useError, element, useInvitations, OnClose, length, validate}) => {
  const [sponsor, useSponsor] = useState<any>(element.sponsor || {one: true, two: false});
  const [team, useTeam] = useState<any>(element.team || []);
  const emailName = useInputValue(element.email, '', 'normal', '', 'email');
  const firstName = useInputValue(element.firstName || '');
  const lastName = useInputValue(element.lastName || '');

  const UTILS = new Utils();
  const isValidInput = UTILS.GetValidationInputPattern();
  const isValidEmail = UTILS.GetValidationEmailPattern();
  function validatedEmail(): boolean {
    if (Number(emailName.value.length) === 0 || !Boolean(isValidEmail.test(emailName.value))) {
      emailName.HandleWarning('Please enter a valid email');
      emailName.HandleStatus('error');
      useError(prev => {
        if (Boolean(prev.filter(el => el.index === 3 && el.deep === index).length)) {
          return prev;
        } else {
          return [...prev, {index: 3, deep: index}];
        }
      });
      return false;
    } else {
      emailName.HandleWarning('');
      emailName.HandleStatus('normal');
      useError(prev => {
        return prev.filter(el => !(el.index === 3 && el.deep === index));
      });
      return true;
    }
  }
  function validatedFirstName(): boolean {
    if (Number(firstName.value.length) === 0 || !Boolean(isValidInput.test(firstName.value))) {
      firstName.HandleWarning('Please enter a valid first name');
      firstName.HandleStatus('error');
      useError(prev => {
        if (Boolean(prev.filter(el => el.index === 1 && el.deep === index).length)) {
          return prev;
        } else {
          return [...prev, {index: 1, deep: index}];
        }
      });
      return false;
    } else {
      firstName.HandleWarning('');
      firstName.HandleStatus('normal');
      useError(prev => {
        return prev.filter(el => !(el.index === 1 && el.deep === index));
      });
      return true;
    }
  }
  function validatedLastName(): boolean {
    if (Number(lastName.value.length) === 0 || !Boolean(isValidInput.test(lastName.value))) {
      lastName.HandleWarning('Please enter a valid last name');
      lastName.HandleStatus('error');
      useError(prev => {
        if (Boolean(prev.filter(el => el.index === 2 && el.deep === index).length)) {
          return prev;
        } else {
          return [...prev, {index: 2, deep: index}];
        }
      });
      return false;
    } else {
      lastName.HandleWarning('');
      lastName.HandleStatus('normal');
      useError(prev => {
        return prev.filter(el => !(el.index === 2 && el.deep === index));
      });

      return true;
    }
  }
  useEffect(() => {
    if (validate === 0) {
      return infoChange({firstName: firstName.value, lastName: lastName.value, email: emailName.value});
    }
    validatedEmail();
    validatedFirstName();
    validatedLastName();
    infoChange({firstName: firstName.value, lastName: lastName.value, email: emailName.value});
  }, [validate, firstName.value, lastName.value, emailName.value]);
  function infoChange({
    team,
    email,
    sponsor,
    lastName,
    firstName,
  }: {
    email?: string;
    lastName?: string;
    firstName?: string;
    team?: object | any;
    sponsor?: object | any;
  }) {
    useInvitations(prev => [
      ...prev.map((el, id) => {
        if (id !== index) {
          return el;
        } else {
          if (firstName) {
            el.firstName = firstName;
          }
          if (lastName) {
            el.lastName = lastName;
          }
          if (team) {
            el.team = team;
          }
          if (email) {
            el.email = email;
          }
          if (sponsor) {
            el.sponsor = sponsor;
          }
          return el;
        }
      }),
    ]);
  }

  function AlternateFocus(hook: any) {
    hook.HandleStatus('normal');
    hook.HandleWarning('');
  }

  function HandleRadiosSponsor(e: any): void {
    if (e.target.id === 'admin') {
      const sponsorship = {one: true, two: false};
      useSponsor(sponsorship);
      infoChange({sponsor: sponsorship});
    } else if (e.target.id === 'coach') {
      const sponsorship = {one: false, two: true};
      useSponsor(sponsorship);
      infoChange({sponsor: sponsorship});
    }
  }

  function handleCancelBadge(element) {
    const modTeams = [...team.filter(el => element._id !== el._id)];
    useTeam(modTeams);
    infoChange({team: modTeams});
  }

  function AddTeam(selectedTeam: any): void {
    useTeam(prev => {
      if (Boolean(prev.filter(el => el.badge === 'ALL').length)) {
        const modTeams = [...prev];
        infoChange({team: modTeams});
        return modTeams;
      } else if (Boolean(prev.length) && selectedTeam.badge === 'ALL') {
        const modTeams = [...prev];
        infoChange({team: modTeams});
        return modTeams;
      } else if (!Boolean(prev.filter(el => selectedTeam._id === el._id).length)) {
        const modTeams = [...prev, selectedTeam];
        infoChange({team: modTeams});
        return modTeams;
      } else {
        const modTeams = [...prev];
        infoChange({team: modTeams});
        return modTeams;
      }
    });
  }

  return (
    <>
      <AdBodyForm data-cy="addCoaches-form-one">
        {length > 1 ? (
          <AdBodyFormHeader>
            <AdBodyFormIcon onClick={() => OnClose(index)} />
          </AdBodyFormHeader>
        ) : (
          <></>
        )}
        <AdBodyFormUp>
          <div>
            <Label text="FIRST NAME" fontWeight="600" fontSize="12px" />
            <InputComponent dynamicSearch={firstName} animateWidth="90%" HandleFocus={() => AlternateFocus(firstName)} />
            <TextWarning status={firstName.status} message={firstName.warningMessage} display="block" />
          </div>
          <div>
            <Label text="LAST NAME" fontWeight="600" fontSize="12px" />
            <InputComponent dynamicSearch={lastName} animateWidth="90%" HandleFocus={() => AlternateFocus(lastName)} />
            <TextWarning status={lastName.status} message={lastName.warningMessage} display="block" />
          </div>
          <div>
            <Label text="EMAIL" fontWeight="600" fontSize="12px" />
            <InputComponent dynamicSearch={emailName} animateWidth="90%" HandleFocus={() => AlternateFocus(emailName)} />
            <TextWarning status={emailName.status} message={emailName.warningMessage} display="block" />
          </div>
        </AdBodyFormUp>
        {sponsor.two && (
          <AdBodyFormSearch>
            <Label text="TEAM" fontWeight="600" fontSize="12px" />
            <PowerInput search={true} onClick={AddTeam} dataArray={teamMemo} selectedTeams={team} handleCancel={handleCancelBadge} placeholder="Choose your team" />
          </AdBodyFormSearch>
        )}
        <AdBodyFormRole>
          <Label text="ROLE" fontWeight="600" fontSize="12px" />
          <RadiosContainer onChange={HandleRadiosSponsor}>
            <Radio title="Admin" name="tableInfo" id="admin" checked={sponsor.one} dynamicActive={sponsor.one} />
            <Radio title="Coach" name="tableInfo" id="coach" checked={sponsor.two} dynamicActive={sponsor.two} />
          </RadiosContainer>
        </AdBodyFormRole>
      </AdBodyForm>
    </>
  );
};

export default ({handleView, teamMemo}) => {
  const spreadsheetRef = useRef<HTMLInputElement | any>(document.createElement('input'));
  const {HandleToastMessage} = useContext(ARMcontext);


  const [invitations, useInvitations] = useState<Array<object | any>>([
    {firstName: '', lastName: '', email: '', team: [], sponsor: {one: true, two: false}},
  ]);
  const [errorEmails, useErrorEmails] = useState<Array<string>>([]);
  const [radio, useRadio] = useState<any>({one: true, two: false});
  const [submitCalled, useSubmitCalled] = useState(false);
  const [validate, useValidate] = useState<number>(0);
  const [error, useError] = useState<Array<any>>([]);
  const [errModal, useErrModal] = useState(false);
  const [loading, useLoading] = useState(false);
  const [unSend, useUnsend] = useState<any>([]);
  const [bulk, useBulk] = useState<any>([]);

  const TEAM = new Teams();
  const UTILS = new Utils();
  const isValidInput = UTILS.GetValidationInputPattern();
  const isValidEmail = UTILS.GetValidationEmailPattern();

  function HandleRadiosButtons(e: any): void {
    if (e.target.id === 'bulk') {
      useRadio({one: false, two: true});
    } else {
      useRadio({one: true, two: false});
    }
  }

  function StartValidations(): void {
    if (radio.one) {
      useValidate(UTILS.GetRandomInt(1, 20));
      if (validate !== 0 && error.length === 0) {
        HandleSubmit();
      }
    } else {
      HandleSubmit();
    }
  }

  async function HandleSubmit(): Promise<void> {
    useLoading(true);
    useValidate(0);
    if (radio.one) {
      if (!Boolean(error.length)) {
        const send = invitations.map(el => {
          let allCounter = false;
          const teams =
            el.team
              ?.map(team => team._id)
              ?.map(team => {
                if (team === undefined) {
                  allCounter = true;
                }
                return team;
              })
              ?.filter(team => team !== undefined) || [];
          const build = {
            firstName: el.firstName,
            lastName: el.lastName,
            email: el.email,
            teams: teams,
            role: el.sponsor.one ? 'Admin' : 'Coach',
            allTeams: el.sponsor.one ? true : allCounter,
          };
          return build;
        });

        const result = await TEAM.InviteMultipleCoaches(send);
        if (result.status) {
          if (result.data.coach_invitations.length) {
            HandleToastMessage('Invitation sent', true, 2500, 'success');
            handleView(false);
          } else {
            HandleToastMessage('User already invited', true, 2000, 'error');
          }
        } else {
          HandleToastMessage(result.data?.message || 'Invitation not sent', true, 2000, 'error');
        }
      } else {
        HandleToastMessage('Make sure all the fields are correct', true, 2000, 'error');
      }
    } else {
      const fail = Array<any>();
      const send = Array<any>();
      bulk.map(el => {
        let allCounter = false;
        const teams = el[3]
          ?.map(team => {
            if (team === undefined) {
              allCounter = true;
            }
            return team;
          })
          .filter(team => team !== undefined);

        const build = {
          firstName: el[0],
          lastName: el[1],
          email: el[2],
          teams: teams,
          role: el[4].one ? 'Admin' : 'Coach',
          allTeams: allCounter,
        };
        if (!Boolean(isValidInput.test(el[0])) || !Boolean(isValidInput.test(el[1])) || !Boolean(isValidEmail.test(el[2]))) {
          fail.push(el);
        } else {
          send.push(build);
        }

        return build;
      });
      if (send.length > 0) {
        if (submitCalled === false) {
          useSubmitCalled(true);
          const result = await TEAM.InviteMultipleCoaches(send);
          if (result.status) {
            useSubmitCalled(false);
            if (result.data.coach_invitations.length) {
              const sended = result.data.coach_invitations.map(send => send);
              let failed = bulk.filter(coachToSend => !sended.includes(coachToSend[2]));
              if (failed.length > 0) {
                failed = failed.filter(failInvitation => !fail.includes(failInvitation));
                if (failed.length > 0) {
                  failed.map(rejected => fail.push(rejected));
                }
              }
              HandleToastMessage(result.data.coach_invitations.length + ' Invitations sent', true, 2500, 'success');
              if (fail.length > 0) {
                useErrModal(true);
                useUnsend(fail);
              } else {
                handleView(false);
              }
            } else {
              HandleToastMessage('One or more coaches already registered', true, 1500, 'error');
              useErrorEmails([...result.data.alreadyCoachs]);
            }
          } else {
            useSubmitCalled(false);
            HandleToastMessage(result.data?.message || 'Invitation not sent', true, 2000, 'error');
          }
        }
      } else {
        HandleToastMessage('invalid data for one or more coaches', true, 1500, 'error');
      }
    }
    useLoading(false);
  }

  function HandleDelete(element) {
    useBulk(prev => [...prev.filter((el, idx) => idx !== element.index)]);
  }

  function HandleDeleteSelected(elementEmail) {
    useBulk(prev => [...prev.filter(el => el[2] !== elementEmail)]);
  }

  function UploadSpreadsheet() {
    spreadsheetRef.current.click();
    spreadsheetRef.current.onchange = () => {
      HandleFiles(spreadsheetRef.current.files);
    };
  }

  function HandleFiles(imported: Array<File>) {
    if (imported[0].name.includes('.csv')) {
      Papa.parse(imported[0], {
        header: true,
        complete: function (results) {
          const duplicates = new Set();
          const extracted = results.data.map(el => {
            el = Object.values(el);
            duplicates.add(`${el[0]}`);
            return el;
          });
          useBulk(prev => {
            if (duplicates.size !== extracted.length) {
              HandleToastMessage('One or more users could be duplicated', true, 2500, 'warning');
            }
            return [...prev, ...extracted.filter(el => el[0] !== 'undefined' && el[0] !== '' && el[0] !== undefined)];
          });
        },
      });
    } else if (imported[0].name.includes('.xlsx') || imported[0].name.includes('.xls')) {
      const files = imported,
        f = files[0];
      const reader = new FileReader();
      const duplicates = new Set();
      reader.onload = function (e: any) {
        const data = e.target.result;
        const readedData = XLSX.read(data, {type: 'binary'});
        const wsname = readedData.SheetNames[0];
        const ws = readedData.Sheets[wsname];
        const dataParse = XLSX.utils.sheet_to_json(ws, {header: 1});
        let parsedData: Array<any> = [
          ...dataParse.filter((el: any) => {
            if (el[0] !== '') {
              duplicates.add(el[2]);
            }
            return el[0] !== undefined;
          }),
        ];
        duplicates.delete(parsedData[0][2]);
        parsedData.shift();
        useBulk(parsedData);
        if (dataParse.length === 0) {
          HandleToastMessage('This file seems to be empty', true, 2500, 'warning');
        } else if (duplicates.size !== dataParse.length - 1) {
          HandleToastMessage('One or more users could be duplicated', true, 2500, 'warning');
        }
      };
      reader.readAsBinaryString(f);
    } else {
      HandleToastMessage('This extension is not supported, try with an .csv, .xlsx file', true, 2500, 'warning');
    }
  }

  function HandleTemplate() {
    window.open('https://docs.google.com/spreadsheets/d/1Ps9vsstfLw28PbpkwFEaIJpfD5YO7DhL6HKcgNNmeek/edit#gid=0', '_blank');
  }

  function handleErrModal() {
    useErrModal(false);
    handleView(false);
  }

  function AddCoach() {
    useInvitations(prev => [...prev, {firstName: '', lastName: '', email: '', team: [], sponsor: {one: true, two: false, three: false}}]);
  }

  function OnClose(index) {
    const aux = invitations;
    useInvitations([]);
    UTILS.Later(100).then(() => useInvitations(aux.filter((el, idx) => index !== idx)));
  }

  return (
    <>
      {errModal ? (
        <Modal title="Invitations not send" margin="10vh auto 200px auto" warningTitle={true}>
          <TableFailedInvitations callback={handleErrModal} failedInvitations={unSend} />
        </Modal>
      ) : (
        <>
          <AdHeader>
            <RadiosContainer onChange={HandleRadiosButtons} data-cy="addCoaches-options">
              <Radio title="Add Individual Coaches" name="tableInfo" id="add" checked={radio.one} dynamicActive={radio.one} />
              <Radio title="Bulk upload" name="tableInfo" id="bulk" checked={radio.two} dynamicActive={radio.two} />
            </RadiosContainer>
          </AdHeader>
          <AdBody>
            {radio.one ? (
              <>
                <div>
                  <AdBodyTitle>Coaches</AdBodyTitle>
                </div>
                {invitations.map((el, idx) => (
                  <IndividualItem
                    key={idx}
                    index={idx}
                    element={el}
                    OnClose={OnClose}
                    teamMemo={teamMemo}
                    validate={validate}
                    useError={useError}
                    length={invitations.length}
                    useInvitations={useInvitations}
                  />
                ))}
                <ExpandedButton text="ADD ANOTHER COACH" icon="plus" callback={AddCoach} dataCy="addCoaches-extra-invitation" />
              </>
            ) : (
              <>
                {!Boolean(bulk.length) ? (
                  <>
                    <div>
                      <AdBodyTitle>Coaches</AdBodyTitle>
                    </div>
                    <AdBodyBulk>
                      <input
                        ref={spreadsheetRef}
                        type="file"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        style={{display: 'none'}}
                      />
                      <AdBodyBulkAdvise onClick={UploadSpreadsheet}>
                        <SpreadSheet />
                        <AdBodyBulkCenter>Upload spreadsheet</AdBodyBulkCenter>
                      </AdBodyBulkAdvise>
                    </AdBodyBulk>
                  </>
                ) : (
                  <>
                    <AdBulkBody>
                      <TableAddCoaches
                        dataTableContent={bulk}
                        teamMemo={teamMemo}
                        handleDelete={HandleDelete}
                        updateTableContent={useBulk}
                        errorData={errorEmails}
                        handleDeleteSelected={HandleDeleteSelected}
                      />
                    </AdBulkBody>
                  </>
                )}
              </>
            )}
          </AdBody>
          {!Boolean(bulk.length) && radio.two ? (
            <AdBulkFooter>
              <LargeButton
                lMargin="0"
                title="CANCEL"
                rMargin="0 40px"
                rColor="#ffffff"
                lColor="#ffffff"
                fColor="#5D6C76"
                bColor="#F0F0F0"
                xMargin="0 10px 0 0"
                dataCy="addCoaches-cancel"
                callback={() => handleView(false)}
              />
              <LargeButton callback={HandleTemplate} rColor="#207245" lColor="#1A643C" icon="excel" title="DOWNLOAD TEMPLATE" />
            </AdBulkFooter>
          ) : (
            <AdFooter>
              <LargeButton
                lMargin="0"
                title="CANCEL"
                rMargin="0 40px"
                rColor="#ffffff"
                lColor="#ffffff"
                fColor="#5D6C76"
                bColor="#F0F0F0"
                xMargin="0 10px 0 0"
                dataCy="addCoaches-cancel"
                callback={() => handleView(false)}
              />
              {loading || submitCalled ? (
                <Loader width="225px" />
              ) : (
                <LargeButton
                  icon="done"
                  rColor="#007AFF"
                  lColor="#006BE1"
                  title="ADD / SEND INVITE"
                  dataCy="addCoaches-submit"
                  callback={StartValidations}
                />
              )}
            </AdFooter>
          )}
        </>
      )}
      ;
    </>
  );
};
